// File: TableCell.tsx
import type { Key } from "react";
import styles from './styles/TableCell.module.css'
import tableStyles from './styles/Table.module.css'
import TimeSlot from "./TimeSlot";
import type { StudentDragItem, StudentOverlayData } from "./StudentOverlay";

interface TableCellProps {
    index?: number | string;
    day: string | number;
    time: string;
    newKey?: Key;
    id: string;
    onDrop: (item: StudentDragItem, day: string | number, time: string) => void;
    onDelete: (elementId: string) => void;
    onLockToggle?: (memberId: string) => void;
    highlightedStudent?: string | null;
    studentOverlays?: StudentOverlayData[] | null;
}

export default function TableCell({
    index,
    day,
    time,
    newKey,
    id,
    onDrop,
    onDelete,
    onLockToggle,
    highlightedStudent,
    studentOverlays,
     }: TableCellProps) {
    return (
        <div className={tableStyles.divTableData} key={newKey}>
            <div className={styles.tableCell}
            data-day={String(index)}
            id={id}
            >
                <TimeSlot
                    time={time}
                    day={day}
                    onDrop={onDrop}
                    onDelete={onDelete}
                    onLockToggle={onLockToggle}
                    highlightedStudent={highlightedStudent}
                    studentOverlays={studentOverlays}

                    />
            </div>
        </div>
        )

}
